function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import gettext from 'js-utils/gettext';
import { noop } from 'lodash';
import CopyField from '../copyField/CopyField';
import ShareBox from '../shareBox/ShareBox';
import { SHARE_BY_COPY } from './constants';
export var ShareModalContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ShareModalContent, _React$Component);

  function ShareModalContent() {
    _classCallCheck(this, ShareModalContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareModalContent).apply(this, arguments));
  }

  _createClass(ShareModalContent, [{
    key: "render",
    // TODO: Add prop types
    value: function render() {
      var shareOptions = this.props.shareOptions;
      var eventUrl = shareOptions.eventUrl,
          eventId = shareOptions.eventId,
          _shareOptions$onClick = shareOptions.onClick,
          onClick = _shareOptions$onClick === void 0 ? noop : _shareOptions$onClick;
      return React.createElement("section", {
        className: "eds-g-cell eds-g-cell-1-1 eds-g-cell--has-overflow"
      }, React.createElement("div", {
        className: "eds-align--center-horizontal eds-l-mar-top-8"
      }, React.createElement(ShareBox, shareOptions)), React.createElement("div", {
        className: "eds-l-mar-top-8"
      }, React.createElement(CopyField, {
        inputFieldId: "event-url-field-".concat(eventId),
        inputFieldStyle: "static",
        label: gettext('Event URL'),
        value: eventUrl,
        onCopyClick: onClick.bind(null, SHARE_BY_COPY)
      })));
    }
  }]);

  return ShareModalContent;
}(React.Component);